export default "__VITE_ASSET__Bz2Va617__"